<template>
  <div class="SidebarLayout-styles-content">
    <h2 class="LimitsHistoryDesktopPage-styles-desktop-title">Limit summary</h2>
    <div class="Paper-styles-paper LimitsHistoryDesktopPage-styles-paper">
      <div class="LimitsHistoryDesktopPage-styles-wrapper LimitsHistoryDesktopPage-styles-empty">
        <img class="LimitsHistoryDesktopPage-styles-empty-icon" src="/static/assets/img/limits_empty.svg" alt="icon" width="83" height="83">
        <p class="LimitsHistoryDesktopPage-styles-empty-message">You don't have any limit updates</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'limitHistory',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/limitHistory.vue